
/* @ngInject */
function AdvancedFiltersCustomFieldsController ($scope, $rootScope, NewAssetService) {
  $scope.addedCustomFields = []
  $scope.addedCustomFieldsValue = []
  $scope.mustShowCustomFields = false
  $scope.customFieldsPagination = {
    top: 10,
    skip: 0
  }

  const api = {
    _getCustomFields,
    _initFormFields,
    _hasMoreResults
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getCustomFields(true)
  }

  const deregisterClearAllFilters = $rootScope.$on('custom-fields.clear-all-filters', () => {
    $scope.addedCustomFields = []
    $scope.addedCustomFieldsValue = []
    api._getCustomFields(false)
  })

  $scope.$on('$destroy', () => {
    deregisterClearAllFilters()
  })

  function _getCustomFields (firstLoad, search) {
    NewAssetService.getCustomFields($scope.customFieldsPagination.top, $scope.customFieldsPagination.skip, search)
      .then(({ rows, count }) => {
        let totalOptionsCount = 0

        $scope.customFields = rows.map(item => {
          const optionsCount = item.options?.length || 0
          totalOptionsCount += optionsCount

          return {
            label: item.title,
            value: item.id,
            type: item.type,
            options: item.options?.map(option => ({ label: option.title, value: option.id })) || []
          }
        })

        $scope.totalOptionsCount = count - totalOptionsCount
        $scope.customFieldsHasMoreOptions = api._hasMoreResults($scope.totalOptionsCount, rows.length)

        if (firstLoad) {
          $scope.mustShowCustomFields = rows.length > 0
        }
      })
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return totalCount > responseLength
  }

  $scope.onSearchCustomFields = (event) => {
    const search = event.detail?.search || ''
    $scope.customFieldsPagination.skip = 0

    api._getCustomFields(false, search)
  }

  $scope.onInfiniteCustomFields = (event) => {
    const search = event.detail?.search || ''

    $scope.customFieldsPagination.skip = $scope.customFieldsPagination.top + $scope.customFieldsPagination.skip

    api._getCustomFields(false, search)
  }

  $scope.onChangeCustomFieldMultiselect = ({ detail: selectedCustomFields }) => {
    $scope.addedCustomFields = selectedCustomFields.map(({ value, type, label, options }) => ({
      value,
      type,
      label,
      options
    }))
    $scope.addedCustomFieldsValue = $scope.addedCustomFields
    api._initFormFields()
  }

  function _initFormFields () {
    if (!$scope.form.customFields) {
      $scope.form.customFields = []
    }
  }

  $scope.onChangeCustomFieldFilter = (index, { detail }, customFieldId, customFieldType) => {
    const { value, date } = detail

    const fieldValue = value || date
    const isFieldValid = fieldValue && customFieldId

    if (isFieldValid) {
      $scope.form.customFields[index] = {
        value: fieldValue,
        customField: customFieldId,
        customFieldType
      }
    } else {
      $scope.form.customFields.splice(index, 1)
    }
  }
}

export { AdvancedFiltersCustomFieldsController }
